import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";

export default function Marketbreadth() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [getRec, setgetRec] = useState(false);
  const [getAllData, setgetAllData] = useState(false);

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getMarketBreadthData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setgetRec(response.data.getRec);
        setgetAllData(response.data.getAllData);
      },
      mobile,
      web_token
    );
  }, [column, mobile, web_token]);

  return (
    <>
      <GlobalHelmet {...Common?.marketBreadth} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Block Deals" />

              <div className="row">
                <div className="col-md-12">
                  <div className="tabelcontiner">
                    <div className="row edit-columns">
                      <div className="col-md-7">
                        <h3>
                          <span className="highlighttext">Market Breadth</span>{" "}
                        </h3>
                      </div>
                      <div className="col-md-3"></div>
                      <div className="col-md-2 text-right">
                        <button
                          className="btn btn-success"
                          title="Reload Page"
                          onClick={refreshPage}
                        >
                          <i className="fa fa-refresh"></i>
                        </button>
                        <Link
                          className="btn btn-success"
                          to="/stock-market-today"
                        >
                          <i className="fa fa-arrow-left"></i>{" "}
                        </Link>
                      </div>
                    </div>

                    <div className="pl-1 pr-4 pb-4 mb-4 ">
                      <div className="row adv-padd">
                        <div className="col-4">
                          <b> Advanced :</b>{" "}
                          {getRec.totadvRec ? getRec.totadvRec : 0}{" "}
                        </div>
                        <div className="col-4">
                          <b>Decline :</b>{" "}
                          {getRec.totDecRec ? getRec.totDecRec : 0}
                        </div>
                        <div className="col-4">
                          <b>Unchanged :</b>{" "}
                          {getRec.totUncRec ? getRec.totUncRec : 0}
                        </div>
                      </div>
                      {getAllData ? (
                        <>
                          <table className="table table-bordered">
                            <thead>
                              <tr className="header-row changefont">
                                <th className="indexname" size="3">
                                  Sectors
                                </th>
                                <th className="ltp" size="3">
                                  ADV/DEC
                                </th>
                                <th className="change" size="3">
                                  %UP Stocks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {getAllData.map((item) => (
                                <tr key={item.id}>
                                  <td>
                                    <Link
                                      to={`/market-breadth-stock/${item.id}`}
                                    >
                                      {item.sector_name} ({item.totalVal})
                                    </Link>
                                  </td>
                                  <td className="  max-100">
                                    <div
                                      className="marketwidth"
                                      style={{
                                        background: item.background,
                                      }}
                                    ></div>
                                    <div className="">
                                      {item.getadvRec}
                                      <label style={{ float: "right" }}>
                                        {item.getdecRec}
                                      </label>
                                    </div>
                                  </td>
                                  <td>{item.upstocks} %</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
